// landing/src/App.jsx
import { useState } from 'react';
import RegisterScreen from './screens/RegisterScreen';
import SuccessScreen  from './screens/SuccessScreen';

export default function App() {
  const [screen, setScreen] = useState('register');
  const [result, setResult] = useState(null);

  const onSuccess = (data) => {
    setResult(data);
    setScreen('success');
  };

  return screen === 'success'
    ? <SuccessScreen result={result} />
    : <RegisterScreen onSuccess={onSuccess} />;
}
